import { DayPeriodEnum } from '@enums/dayPeriod.enum';
import { createStringArray } from '@helpers/createTimeStringArray/createStringArray';

export const hoursConfig = createStringArray(12, { withoutZero: true });

export const minutesConfig = createStringArray(60);

export const dayPeriodConfig: DayPeriodEnum[] = [DayPeriodEnum.AM, DayPeriodEnum.PM];
